import React, { useEffect } from "react";
import { format } from "date-fns";
import Button from "@material-ui/core/Button";
import axios from "../../../utils/Axios/axiosProxy";
import { MultilineInput } from "../../../components/FormInputs/FormInputs";

import "../../../components/MessagePopup/MessagePopup.scss";

export default function AdminMessagePopup({
  content,
  updateContent,
  updateMessages,
}) {
  const [newMessage, setNewMessage] = React.useState({
    date: new Date(),
    message: "",
    sender: "admin",
    seen: false,
  });
  useEffect(() => {
    const markMessageSeen = (route, data) => {
      axios
        .patch(route, data, {
          headers: {
            /* Authorization: `Bearer ${JWT}`, */
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("MARK MESSAGE SEEN RESPONSE: ", response.statusText);
          updateMessages(response.data.messages);
          updateContent();
        })
        .catch((error) => {
          console.log("MARK MESSAGE SEEN ERROR: ", error);
        })
        .catch((error) => console.log("MARK MESSAGE SEEN CLIENT ERROR", error));
    };
    if (content.seen === false) {
      markMessageSeen("/api/communication/seen", {
        userID: content.userID,
        threadID: content.dialogData._id,
        sender: "user",
      });
    }
  }, [content, updateMessages, updateContent]);

  const sendMessage = (route, data) => {
    axios
      .patch(route, data, {
        headers: {
          /* Authorization: `Bearer ${JWT}`, */
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("SEND MESSAGE RESPONSE: ", response.statusText, response);
        updateMessages(response.data.messages);
        setTimeout(() => {
          updateContent();
        }, 1500);
        setNewMessage({
          date: new Date(),
          message: "",
          sender: "admin",
          seen: false,
        });
      })
      .catch((error) => {
        console.log("SEND MESSAGE ERROR: ", error);
      })
      .catch((error) => console.log("SEND MESSAGE CLIENT ERROR", error));
  };

  return (
    <div className="MessagePopupContainer">
      <div className="Heading">Messages</div>
      <div className="Padding">
        <div>
          <p className="ThreadID">{content.threadID}</p>
          {content.dialogData.messages.map((item, i) => {
            return (
              <div key={i} className="BottomBorder">
                <p className="Message">
                  {`${item.message} `}
                  <span className="MessageDate">({item.sender})</span>
                </p>
                <p className="MessageDate">
                  {format(new Date(item.date), "yyyy-MM-dd")}
                </p>
              </div>
            );
          })}
          <MultilineInput
            value={newMessage.message}
            onChange={(event) =>
              setNewMessage({ ...newMessage, message: event.target.value })
            }
          />
        </div>

        <div className="MarginHorizontal FloatRight">
          <Button
            onClick={() => {
              sendMessage("/api/communication/message", {
                userID: content.userID,
                threadID: content.threadID,
                newMessage: newMessage,
              });
            }}
            className="ToreaBay Small"
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
}
